<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row>
            <!--<a-col :span="12" style="display: flex;">-->
            <a-row :gutter="16">
              <a-col :span="6">
                <a-form-item label="安装类别">
                  <a-select  v-model="queryParam.installationType" allowClear="true">
                    <a-select-option  v-for="type in restaurantTypes" :title="type.label" :key="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="金额类型">
                  <a-input v-model="queryParam.priceName"/>
                  <!--<a-select  v-model="queryParam.fieldType" style="width: 210px;">-->
                  <!--<a-select-option  v-for="type in restaurantTypes1" :key="type.code">{{type.label}}</a-select-option>-->
                  <!--</a-select>-->
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="成本类型">
                  <a-select v-model="queryParam.costType" allowClear="true">
                    <a-select-option  v-for="type in restaurantTypes1" :title="type.label" :key="type.code">{{type.label}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6" :style="{ textAlign: 'right' }">
                <a-button type="primary" htmlType="submit" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px;" @click="() => queryParam = {}">清空</a-button>
              </a-col>
            </a-row>
            <!--</a-col>-->
          </a-row>
        </a-form>
      </div>
      <a-divider/>
      <a-row>
        <a-col :span="5" :offset="19" :style="{ textAlign: 'right' }">
          <a-button v-if="editEnabel" type="primary" icon="plus" @click="$refs.modal.add()">新增</a-button>
          <!--<a-dropdown v-if="removeEnable&&selectedRowKeys.length > 0">-->
          <!--<a-button type="danger" icon="delete" style="width: 120px;" @click="delByIds(selectedRowKeys)">删除</a-button>-->
          <!--</a-dropdown>-->
        </a-col>
      </a-row>
      <s-table
        style="margin-top: 20px"
        size="default"
        ref="table"
        rowKey="channelId"
        :columns="columns"
        :data="loadData"
        bordered
      >
        <span slot="installationType" slot-scope="text, record">
          <td v-for="type in restaurantTypes" :key="type.code" v-if="record.installationType == type.code">{{type.label}}</td>
        </span>
          <span slot="costType" slot-scope="text, record">
          <td v-for="type in restaurantTypes1" :key="type.code" v-if="record.costType == type.code">{{type.label}}</td>
        </span>
        <span slot="action" slot-scope="text, record">
          <a v-if="queryList" @click="handleEdit(record,1)">查看</a>
          <a-divider v-if="queryList" type="vertical"/>
          <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
          <a-divider v-if="deleteEnable && editEnabel" type="vertical"/>
          <a v-if="deleteEnable" @click="delByIds(record.id)">删除</a>
          <!--<a-divider type="vertical" />-->
          <!--<a v-if="record.delStatus==1" @click="showState(record.channelId,record.forbiddenStatus)">启用</a>-->
          <!--<a v-else @click="showState(record.channelId,record.forbiddenStatus)">禁用</a>-->
        </span>
      </s-table>
      <amount-modal ref="modal" @ok="handleOk"></amount-modal>
    </a-card>
    <no-authority v-else></no-authority>
  </div>
</template>
<script>

  import { STable } from '@/components'
  import { getBasicPriceList,remove } from '@/api/basicdatas/AmountManagement'
  import AmountModal from './modules/AmountModal.vue'
  import NoAuthority from '../enterprise/NoAuthority.vue'
  import { checkPermission } from '@/utils/permissions'
  import {getDictMap} from "../../utils/dict"

  export default {
    name: 'TableList',
    components: {
      STable,
      AmountModal,
      NoAuthority
    },
    data () {
      return {
        form: this.$form.createForm(this),
        mdl: {},
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '序号',
            width:60,
            dataIndex: 'num',
            align:'center',
          },
          {
            title: '操作',
            width:60,
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
          {
            title: '安装类别',
            dataIndex: 'installationType',
            scopedSlots: { customRender: 'installationType' },
            align:'center',
          },
          {
            title: '金额类型',
            dataIndex: 'priceName',
            align:'center'
          },
          {
            title: '成本类型',
            dataIndex: 'costType',
            scopedSlots: { customRender: 'costType' },
            align:'center'
          },
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return getBasicPriceList(Object.assign(parameter, this.queryParam))
        },
        data:[],
        restaurantTypes: [],
        restaurantTypes1: [],
        // remindMap,
        // fieldType,
        editEnabel: checkPermission('basicdatas:AmountManagement:edit'),
        deleteEnable: checkPermission('basicdatas:AmountManagement:delete'),
        queryList: checkPermission('basicdatas:AmountManagement:query'),
      }
    },
    async created () {
      // document.body.addEventListener('keyup', e => {
      //   if (e.keyCode == 13) {
      //     this.$refs.table.refresh(true)
      //   }
      // })
      this.restaurantTypes = [];
      this.restaurantTypes1 = [];
      this.restaurantOperTypeMap = await getDictMap('install_type');
      this.restaurantOperTypeMap1 = await getDictMap('cost_type');
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes.push({code: key, label: value})
      })
      this.restaurantOperTypeMap1.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes1.push({code: key, label: value})
      })
    },
    // destroyed () {
    //   document.body.removeEventListener('keyup', e => {})
    // },
    methods: {
      handleAdd () {
        this.$refs.modal.add()
      },
      handleEdit (record,status) {
        // console.log(record)
        this.$refs.modal.edit(record,status)
      },
      handleOk (value) {
        if(value == 1){
          this.$refs.table.refresh(true)
        }else{
          this.$refs.table.refresh()
        }
        // console.log('handleSaveOk')
      },
      delByIds (id) {
        let that = this
        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
            remove({ 'id': id }).then(res => {
              if (res.code === 0) {
                that.$message.success('删除成功')
                that.handleOk()
              } else {
                that.$message.error(res.msg)
              }
            })
          },
          onCancel() {
            console.log('Cancel');
          },
        });
      }
    },
    watch: {
      /*
          'selectedRows': function (selectedRows) {
            this.needTotalList = this.needTotalList.map(item => {
              return {
                ...item,
                total: selectedRows.reduce( (sum, val) => {
                  return sum + val[item.dataIndex]
                }, 0)
              }
            })
          }
          */
    }
  }
</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap;padding: 4px 16px;}
  /deep/ .ant-table-content{
    width:50%
  }
</style>